import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  FormControlLabel,
  Checkbox,
  IconButton,
  InputAdornment,
} from "@mui/material";
import { Grid } from "@mui/material";
import { Link } from "@mui/material";
import { useNavigate } from "react-router-dom";
import cover from "../Assets/Images/Login_image.png";
import logo from "../Assets/logo small.png";
import { loginUser } from "../services/LoginService";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import { Visibility, VisibilityOff } from "@mui/icons-material";

const LoginPage: React.FC = () => {
  const navigate = useNavigate();

  const [emailValue, setEmailValue] = useState("");
  const [emailPassword, setEmailPassword] = useState("");
  const [error, setError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [serverError, setServerError] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    getDeviceFingerprint();
  }, []);

  const getDeviceFingerprint = async (): Promise<string> => {
    const fp = await FingerprintJS.load();
    const result = await fp.get();
    const visitorId = result.visitorId;
    console.log(visitorId);
    return visitorId;
  };

  const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEmailValue(event.target.value);
    setError(false);
    setServerError("");
  };

  const handlePasswordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEmailPassword(event.target.value);
    setPasswordError(false);
    setServerError("");
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const handleLogin = async () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (emailValue.trim() === "") {
      setError(true);
      setServerError("Email is required");
      return;
    }

    if (!emailRegex.test(emailValue)) {
      setError(true);
      setServerError("Please enter a valid email");
      return;
    }

    if (emailPassword.trim() === "") {
      setPasswordError(true);
      setServerError("Password is required");
      return;
    }

    try {
      const data = await loginUser(emailValue, emailPassword);
      console.log("Login successful:", data.message);

      if (data.token) {
        localStorage.setItem("authToken", data.token);
      }

      navigate("/MasterScreen");
    } catch (err: any) {
      console.error("Login error:", err.message);
      setServerError(err.message || "Invalid email or password");
    }
  };

  return (
    <Box sx={{ flex: 1 }}>
      <Grid container spacing={0} sx={{ height: "100vh" }}>
        <Grid xs={0} md={6} lg={6}>
          <Box sx={{ height: "100%", padding: 2 }}>
            <Box
              sx={{
                height: "100%",
                backgroundImage: `url(${cover}),linear-gradient(to bottom, rgb(255, 255, 255), rgba(167, 223, 255, 0.38))`,
                backgroundSize: "contain",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                borderRadius: 5,
              }}
            />
          </Box>
        </Grid>

        <Grid
          xs={12}
          md={6}
          lg={6}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              width: "100%",
              maxWidth: 600,
              padding: 4,
              backgroundColor: "white",
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                display: "flex",
                marginBottom: 2,
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Box>
                <img
                  src={logo}
                  alt="Collapsed Logo"
                  style={{ width: "30px", height: "auto", marginRight: 10 }}
                />
              </Box>
              <Box>
                <Typography
                  sx={{ marginBottom: 1, fontWeight: "400", fontSize: 30 }}
                  align="left"
                >
                  Hawkye
                </Typography>
              </Box>
            </Box>

            <form onSubmit={(e) => e.preventDefault()}>
              <TextField
                label="Email"
                type="email"
                fullWidth
                variant="outlined"
                margin="normal"
                required
                value={emailValue}
                onChange={handleEmailChange}
                error={error}
                helperText={error ? serverError : ""}
              />

              <Box sx={{ margin: 1 }}></Box>

              <TextField
                label="Password"
                type={showPassword ? "text" : "password"}
                fullWidth
                variant="outlined"
                margin="normal"
                required
                value={emailPassword}
                onChange={handlePasswordChange}
                error={passwordError}
                helperText={passwordError ? "Password is required" : ""}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={togglePasswordVisibility} edge="end">
                        {showPassword ? <Visibility /> : <VisibilityOff />}

                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />

              {serverError && (
                <Typography variant="body2" color="error" sx={{ mt: 1 }}>
                  {serverError}
                </Typography>
              )}

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <FormControlLabel
                  control={<Checkbox defaultChecked />}
                  label="Remember me"
                  sx={{
                    "& .MuiFormControlLabel-label": {
                      fontSize: "14px",
                    },
                  }}
                />
                <Link
                  href="/forgot-password"
                  variant="body2"
                  underline="hover"
                  sx={{ cursor: "pointer" }}
                >
                  Forgot Password?
                </Link>
              </Box>

              <Button
                variant="contained"
                color="primary"
                size="large"
                fullWidth
                sx={{ marginTop: 3 }}
                onClick={handleLogin}
              >
                Login
              </Button>
            </form>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default LoginPage;
